export default "__VITE_ASSET__jxqCtM6H__"